// @core/api/endpoints/notifications/list_notification_templates.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListNotificationTemplatesResponse,
} from '../../../types/notifications';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/notifications';

/**
 * List notification templates
 * Returns a paginated list of all notification templates. Supports filtering by template type and status.
 */
export async function ListNotificationTemplates(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListNotificationTemplatesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/templates`;
  const requestOptions = options;
  return client.get<ListNotificationTemplatesResponse>(requestPath, { ...requestOptions, params });
}
